import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, inject, Input, OnChanges, OnDestroy, OnInit, Output, output, PLATFORM_ID, signal, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, Subject, takeUntil } from 'rxjs';
import { LoaderComponent } from '../loader/loader.component';
import { DataUnavailableComponent } from '../data-unavailable/data-unavailable.component';
import { SideMenuComponent } from '../../../Components/side-menu/side-menu.component';
import { SideMenuContentRenderComponent } from '../../../Components/side-menu-content-render/side-menu-content-render.component';
import { LoadJsonServiceService } from '../../../Services/Common/load-json-service.service';
import { MenuJson, SideItem } from '../../../Model/model';
import { SelectMenuOptionService } from '../../../Services/SelectOption/select-menu-option.service';
import { EventEmitterService } from '../../../Services/Common/event-emitter.service';
import { RatingComponent } from '../rating/rating.component';
import { forceScrollTop } from '../../../core/utils/scroll.util';
import { AuthService, TokenService } from '../../../Services/auth';
import { ApiService } from '../../../Services/api';
import { ApiConstants } from '../../../Services/api/ApiConstants';
import { SecureStorageService } from '../../../Services/cache';

@Component({
  selector: 'app-side-nav',
  imports: [MatIconModule, CommonModule, RatingComponent, LoaderComponent, DataUnavailableComponent, SideMenuComponent, SideMenuComponent, SideMenuContentRenderComponent],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavComponent implements OnInit, AfterViewInit, OnDestroy {

  private svc = inject(LoadJsonServiceService)
  readonly data = signal<MenuJson | null>(null);
  readonly selectedId = signal<string>('');
  private dataContent: any;
  contentSection: any
  @Input() pageDetails!: string | undefined;
  @Input() parentComponent?: any;
  @Output() contentLoded = new EventEmitter<string>();
  selectedAccordion: string = '';
  showLoading: boolean = true;
  showContent: boolean = false;
  isStickySidebar = false
  isSidebarVisible = false;
  showDropdown = false;
  showtaxpayer: boolean = true
  noData: boolean = false;
  showShimmer: boolean = true;
  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  // Helper method to determine if this is a single page (no side menu)
  isSinglePage(): boolean {
    const sideMenuLength = this.data()?.sideMenu?.length || 0;
    return sideMenuLength === 0;
  }

  // Firefox-compatible scroll to top method
  private scrollToTop(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    try {
      forceScrollTop();
    } catch (error) {
      console.warn('Scroll to top failed:', error);
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.showDropdown = false;
  }
  viewDone = false;
  selectedMenu = '';
  last = '';
  routeSub!: any;
  //BreadCrumb
  isSmallScreen: boolean = typeof window !== 'undefined' ?
    window.innerWidth < 650 : false;
  secondaryLabel = '';
  initalLabel: string = '';
  breadcrumblabels: any;
  private destroy$ = new Subject<void>();
  private isLoadingData: { [key: string]: boolean } = {};

  // Auth-related
  isLoggedIn = false;
  readonly publicMenuAllowed = ['contact-information', 'call-center'];
  private authService: AuthService = inject(AuthService);


  constructor(private sel: SelectMenuOptionService, private apiService: ApiService, private router: Router, private bus: EventEmitterService, private cdr: ChangeDetectorRef, private AcRouter: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, private location: Location, private secureStorage: SecureStorageService, private tokenService: TokenService) {
    // console.log("the initial load page details ...", this.pageDetails);
    bus.on()
      .pipe(takeUntilDestroyed())
      .subscribe(ev => {
        if (ev) {
          // Handle refresh events from delete operations
          if (ev.startsWith('refresh-')) {
            const contentId = ev.replace('refresh-', '');
            // console.log(`Received refresh event for: ${contentId}`);
            this.refreshDataForContent(contentId);
            return;
          }

          this.selectedMenu = ev;
          this.cdr.markForCheck();
          // console.log('after reset', this.selectedMenu);
          // this.setContent();
        }
      })

    // this.router.events
    //   .pipe(
    //     filter(event => event instanceof NavigationEnd)
    //   )
    //   .subscribe(() => {
    //     window.scrollTo(0, 0);
    //     if (this.router.url === '/taxpayer/appointtaxAgents') {
    //       this.showtaxpayer = false
    //       console.log('Router event - NavigationEnd', this.router.url);
    //     } 

    //   });
  }

  private applyAuthFilter(workJson: any) {
    if (!workJson) return workJson;
    // prefer explicit check against AuthService in case local flag is stale
    try {
      if (typeof this.authService?.isLoggedIn === 'function') {
        if (this.authService.isLoggedIn()) return workJson;
      } else if (this.isLoggedIn) {
        return workJson;
      }
    } catch (e) {
      // fallback to local flag
      if (this.isLoggedIn) return workJson;
    }

    const allowed = new Set(this.publicMenuAllowed);
    const cloned: any = { ...workJson };

    try {
      if (Array.isArray(cloned.sideMenu)) {
        cloned.sideMenu = cloned.sideMenu.filter((s: any) => allowed.has(s.contentId));
      } else {
        cloned.sideMenu = [];
      }

      const newMenuContent: any = {};
      if (cloned.menuContent && typeof cloned.menuContent === 'object') {
        Object.keys(cloned.menuContent).forEach(k => {
          if (allowed.has(k)) newMenuContent[k] = cloned.menuContent[k];
        });
      }
      cloned.menuContent = newMenuContent;

      const currentSelected = this.selectedId?.() || '';
      if (!allowed.has(currentSelected)) {
        const first = cloned.sideMenu && cloned.sideMenu.length > 0 ? cloned.sideMenu[0].contentId : (Object.keys(cloned.menuContent)[0] || '');
        if (first) {
          try {
            this.selectedId.set(first);
            const route = cloned.menuContent?.[first]?.route;
            if (route) {
              void this.router.navigateByUrl(route.startsWith('/') ? route : `/${route}`);
            }
          } catch (e) { }
        }
      }
    } catch (e) {
      console.warn('applyAuthFilter encountered an error', e);
    }

    return cloned;
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => {
        this.isSidebarVisible = false;
      });
    // console.log('Data received in child from ng on init:', this.pageDetails);
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Clear viewingDifferentUser flag when navigating to home or dashboard
        const currentUrl = this.router.url.toLowerCase();
        if (currentUrl === '/' || currentUrl.startsWith('/dashboard') || currentUrl === '/home') {
          try {
            // Remove encrypted flag from secure session storage
            this.secureStorage.remove('viewingDifferentUser', true);
          } catch (e) { /* ignore */ }
        }

        setTimeout(() => this.setContent(), 0);

        // Firefox-compatible scroll to top
        this.scrollToTop();

      });

    // Subscribe to auth changes but only re-apply filtering when current route is a help route
    try {
      (this.authService.loggedIn$ as import('rxjs').Observable<boolean>).pipe(takeUntil(this.destroy$)).subscribe((v: boolean) => {
        this.isLoggedIn = !!v;
        try {
          if (String(this.router.url || '').toLowerCase().includes('/help')) {
            if (this.dataContent) {
              const filtered = this.applyAuthFilter(JSON.parse(JSON.stringify(this.dataContent)));
              this.dataContent = filtered;
              this.data.set({ ...filtered });
              this.cdr.markForCheck();
            }
          }
        } catch (err) {
          console.warn('Failed to apply auth filter after login state change', err);
        }
      });
    } catch (e) {
      console.warn('AuthService subscribe failed', e);
    }

    this.setContent();
  }

  private isViewingDifferentUser(): boolean {
    try {
      const val = this.secureStorage.get<any>('viewingDifferentUser', true);
      if (val === null || val === undefined) return false;
      if (typeof val === 'string') return val.trim().length > 0;
      return !!val;
    } catch (e) {
      return false;
    }
  }


  private getViewingDifferentUserBin(): string | null {
    try {
      let val = this.secureStorage.get<any>('viewingDifferentUser', true);
      console.log('Retrieved viewingDifferentUser from secure storage:', val, typeof val);
      if (!val) return null;
      if (typeof val === 'number') val = String(val); // guard against unexpected boolean values
      if (typeof val === 'string') {
        const s = val.trim();
        if (s.toLowerCase() === 'true') return null;
        return s || null;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  ngAfterViewInit(): void {
    // console.log("view rendered");
    this.viewDone = true;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.scrollToTop();
      }, 0);
    }
  }

  getBreadCrumbLabels(data: any) {
    this.initalLabel = data["pageName"]
    this.breadcrumblabels = {
      mainPage: data["mainPage"] ? data["mainPage"] : '',
      subpage: data['subpage'] ? data['subpage'] : '',
      intermediatePage: data['intermediatePage'] ? data['intermediatePage'] : ''
    }
    const route = this.location.path();
    const segments = route.split('/').filter(s => s);
    const currentSection = segments[segments.length - 1];
    // console.log('currentSection', currentSection);
    const menuContent = data["menuContent"] || {};
    const sideMenuArr: any[] = Array.isArray(this.dataContent?.["sideMenu"]) ? this.dataContent["sideMenu"] : [];
    if (menuContent[currentSection]) {
      this.secondaryLabel = menuContent[currentSection]?.tab;
    } else if (sideMenuArr.length > 0) {
      const firstKey = sideMenuArr[0]?.contentId;
      if (firstKey && menuContent[firstKey]) {
        this.secondaryLabel = menuContent[firstKey]?.tab;
      } else {
        console.warn("No route found for the first menu item or missing menuContent entry.");
        this.secondaryLabel = '';
      }
    } else {
      console.warn("sideMenu missing or empty; no secondary label.");
      this.secondaryLabel = '';
    }
    // console.log(this.breadcrumblabels, data["mainPage"], route, this.secondaryLabel, "breadcrumblabels")
  }

  routeToInitialPage() {
    if (this.dataContent?.["route"]) {
      this.router.navigate([this.dataContent["route"]]);
      this.showDropdown = false;
      return;
    }
    const sideMenuArr: any[] = Array.isArray(this.dataContent?.["sideMenu"]) ? this.dataContent["sideMenu"] : [];
    if (sideMenuArr.length === 0) {
      console.warn("routeToInitialPage: sideMenu empty, aborting navigation.");
      return;
    }
    // Prefer first non-disabled item that has a valid route
    const firstItem = sideMenuArr.find((s: any) => {
      const key = s.contentId;
      const route = this.dataContent?.["menuContent"]?.[key]?.route;
      return !s.disabled && route;
    });

    const firstKey = firstItem?.contentId;
    const firstRoute = this.dataContent?.["menuContent"]?.[firstKey]?.route;
    if (firstKey && firstRoute && !firstItem?.disabled) {
      this.router.navigate([firstRoute]);
      this.secondaryLabel = this.dataContent?.["menuContent"]?.[firstKey]?.tab || '';
    } else {
      console.warn("routeToInitialPage: missing first route or key or item disabled.");
    }
    this.showDropdown = false;
  }

  routeToPage(route: string) {
    // console.log(route, "routingTo:")
    this.router.navigate([`/${route}`])
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isSmallScreen = event.target.innerWidth < 650;
  }

  onSelect(item: SideItem) {
    if (!item || (item as any).disabled) {
      // console.log('Attempt to select disabled menu item', item);
      return;
    }
    const menuContent = (this.dataContent as any)?.menuContent?.[item?.contentId];
    if (menuContent && (menuContent._disabled === true || menuContent.disabled === true)) {
      // console.log('Attempt to select menuContent that is disabled', item?.contentId);
      return;
    }

    let resolvedContentId = item?.contentId;
    try {
      if (item?.contentId === 'acc') {
        const sideMenuArr: any[] = Array.isArray(this.dataContent?.sideMenu) ? this.dataContent.sideMenu : [];
        if (sideMenuArr.length > 1 && sideMenuArr[1] && sideMenuArr[1].contentId) {
          resolvedContentId = sideMenuArr[1].contentId;
        } else if (sideMenuArr.length > 0 && sideMenuArr[0] && sideMenuArr[0].contentId) {
          resolvedContentId = sideMenuArr[0].contentId;
        }
      }
    } catch (e) {
      console.warn('Error resolving dynamic contentId for acc mapping', e);
    }

    this.contentLoded.emit(resolvedContentId);
    if (menuContent?.route) {
      const targetRoute = menuContent.route.startsWith('/') ? menuContent.route : `/${menuContent.route}`;
      void this.router.navigateByUrl(targetRoute);
      return;
    } else {
      const url = this.router.url;
      const segments = url.split('/').filter(s => s);
      const newRoute = `/${segments[0]}/${resolvedContentId}`;
      this.router.navigate([newRoute]);
    }
  }

  toggleSidebar(): void {
    this.isSidebarVisible = !this.isSidebarVisible;
  }


  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.isStickySidebar = scrollY > 10;
  }

  setContent() {
    this.showLoading = true;
    this.showContent = false;
    // console.log('Router URL:', this.router.url);
    if (isPlatformBrowser(this.platformId)) {
      if (!this.pageDetails) {
        // console.log('No pageDetails provided, returning');
        return;
      }

      const url = this.router.url;
      const segments = url.split('/').filter(s => s);
      // console.log('URL segments:', segments);

      const pathConfig = {
        'userProfile': 'assets/JSONData/user-profile/userProfile.json',
        'sitemap': 'assets/JSONData/footer/sitemap.json',
        'privacy-policy': 'assets/JSONData/footer/privacy-policy.json',
        'terms-of-use': 'assets/JSONData/footer/terms-of-use.json',
        'about-us': 'assets/JSONData/footer/about-us.json',
        'accessibility': 'assets/JSONData/footer/accessibility.json',
        'contactInfo': 'assets/JSONData/footer/contact-info.json',
        'help': 'assets/JSONData/help/help.json'
      } as const;

      type PageKey = keyof typeof pathConfig;

      const pageDetails = this.pageDetails as string;

      const dataPath =
        (pathConfig as Record<string, string>)[pageDetails] ??
        `assets/JSONData/${pageDetails}.json`;

      // console.log(dataPath, 'dataPath', pageDetails);

      // console.log('Page details:', this.pageDetails);

      this.svc.load(dataPath).subscribe({
        next: (json) => {
          // console.log('Data loaded successfully:', json);
          let workJson: any;
          try {
            workJson = JSON.parse(JSON.stringify(json));
          } catch (cloneErr) {
            // console.warn('Deep clone failed, falling back to original json reference', cloneErr);
            workJson = json;
          }

          // Current URL Check
          try {
            const currentUrl = String(this.router?.url || '').toLowerCase();
            if (currentUrl.includes('account')) {

              try {
                const storedRole = String(this.secureStorage.get<string>('user_role', true) || '').toLowerCase();
                const tokenRole = String(this.tokenService.getUserProfile()?.role || '').toLowerCase();
                const roleStr = (storedRole || tokenRole || '').toLowerCase();

                // If the JSON provides explicit flags, use them. Priority rules:
                // - If role is 'team' => show only items with teamUser === true (if key present)
                // - If role is 'tin'  => show only items with tinUser === true (if key present)
                // - If role unrecognized => remove items that explicitly target a role
                const sideArr = Array.isArray(workJson.sideMenu) ? workJson.sideMenu : [];
                // console.log('Original sideMenu length:', roleStr);
                workJson.sideMenu = sideArr.filter((s: any) => {
                  try {
                    const hasTeamFlag = Object.prototype.hasOwnProperty.call(s, 'teamUser');
                    const hasTinFlag = Object.prototype.hasOwnProperty.call(s, 'tinUser');
                    if (roleStr === 'teammember') {
                      if (hasTeamFlag) return !!s.teamUser;
                      return true;
                    } else if (roleStr === 'tin') {
                      if (hasTinFlag) return !!s.tinUser;
                      return true;
                    } else {
                      return true
                    }
                  } catch (e) {
                    return true;
                  }
                });

                // Build a set of allowed contentIds from the filtered sideMenu
                const allowedIds = new Set((workJson.sideMenu || []).map((s: any) => s?.contentId).filter(Boolean));
                // console.log('Allowed contentIds after role filter:', allowedIds);

                // Additional filter: Remove "Reset Password" when viewing a different user's account (from BIN details)
                if (this.isViewingDifferentUser()) {
                  workJson.sideMenu = (workJson.sideMenu || []).filter((s: any) => {
                    return s?.contentId !== 'reset-password';
                  });
                  allowedIds.clear();
                  (workJson.sideMenu || []).forEach((s: any) => {
                    if (s?.contentId) allowedIds.add(s.contentId);
                  });
                }

                if (workJson.menuContent && typeof workJson.menuContent === 'object') {
                  const keys = Object.keys(workJson.menuContent);
                  for (const k of keys) {
                    try {
                      const entry = (workJson.menuContent as any)[k];
                      if (!entry) { delete (workJson.menuContent as any)[k]; continue; }
                      if (!allowedIds.has(k)) { delete (workJson.menuContent as any)[k]; continue; }
                    } catch (e) { /* ignore per-item errors */ }
                  }
                }
              } catch (e) {
                console.warn('Failed to apply role-based menu filter', e);
              }
            }
          } catch (e) {
            console.warn('Failed to apply role-based menu filter', e);
          }

          // Refresh login state from AuthService (synchronous) and apply auth filter only for help routes on initial load
          try {
            if (typeof this.authService?.isLoggedIn === 'function') {
              this.isLoggedIn = this.authService.isLoggedIn();
            }
          } catch (e) { /* ignore */ }

          const isHelpRoute = String(this.router.url || '').toLowerCase().includes('/help');
          const filteredJson = isHelpRoute ? this.applyAuthFilter(workJson) : workJson;
          this.dataContent = filteredJson;
          // console.log("dataContent", this.dataContent)
          this.data.set({ ...filteredJson });
          this.getBreadCrumbLabels(filteredJson)
          // ensure following logic uses the filtered JSON
          workJson = filteredJson;
          const lastSegment = segments[segments.length - 1];
          const sideMenuArr: any[] = Array.isArray(workJson.sideMenu) ? workJson.sideMenu : [];
          const matchedItem = sideMenuArr.find(item => item.contentId === lastSegment);

          // If user manually navigates to an individual-only route (removed earlier),
          // redirect them to the profile page. This handles cases where the sideMenu
          // entry was removed for 'individual' profile but user types the URL directly.
          try {
            const profileTypeCheck = String(this.tokenService.getUserProfile()?.profile || '').toLowerCase();
            const removedForIndividual = new Set(['bank-details', 'team-members']);
            // if ((profileTypeCheck === 'individual' || profileTypeCheck.includes('individual')) && removedForIndividual.has(lastSegment)) {
            //   const profileRoute = workJson.menuContent?.['profile']?.route || `/${segments[0]}/profile` || '/account/profile';
            //   this.selectedId.set('profile');
            //   this.showLoading = false;
            //   this.showContent = true;
            //   this.cdr.detectChanges();
            //   if (this.router.url !== profileRoute) {
            //     const routeToUse = profileRoute.startsWith('/') ? profileRoute : `/${profileRoute}`;
            //     void this.router.navigateByUrl(routeToUse);
            //   }
            //   return;
            // }
          } catch (redirErr) {
            console.warn('Redirect check for removed individual pages failed', redirErr);
          }

          if (matchedItem?.contentId === 'bank-details' || matchedItem?.contentId === 'team-members') {
            this.showShimmer = true
            this.noData = false;
            this.callAPItoGetData(workJson, matchedItem?.contentId);
          } else {
            this.data.set({ ...workJson });
          }

          // console.log(lastSegment, this.selectedAccordion, this.selectedMenu, "lastSegment")

          const menuParamRaw = this.AcRouter?.snapshot?.queryParams?.['menu'];
          const normalize = (v: any) => (v ? String(v).trim() : '');
          const menuParam = normalize(menuParamRaw);

          let initialContentId = '';

          if (menuParam) {
            const bySide = sideMenuArr.find(s => normalize(s.contentId) === menuParam || normalize(s.label) === menuParam);
            if (bySide) {
              initialContentId = bySide.contentId;
            } else if (json.menuContent && json.menuContent[menuParam]) {
              initialContentId = menuParam;
            }
          }

          if (!initialContentId) {
            initialContentId = matchedItem?.contentId || sideMenuArr[0]?.contentId || '';
          }

          // console.log('Setting initial selectedId:', initialContentId);
          this.selectedId.set(initialContentId);

          // If sideMenu empty, attempt to derive selectedId by matching route inside menuContent entries
          if (sideMenuArr.length === 0) {
            // Default to 'overview' if available since privacy-policy and similar pages expose content under 'overview'
            if (json.menuContent && (json.menuContent as any)['overview'] && !this.selectedId()) {
              this.selectedId.set('overview');
              // console.log('Defaulting selectedId to overview for empty sideMenu');
            }
            if (json.menuContent) {
              // 1. Direct key match (legacy behavior)
              if (json.menuContent[lastSegment]) {
                this.selectedId.set(lastSegment);
                // console.log('Direct key matched menuContent without sideMenu');
              } else {
                // 2. Route match: find entry whose route equals current URL or '/'+lastSegment
                const routeMatchKey = Object.keys(json.menuContent).find(key => {
                  const entry = json.menuContent[key];
                  const routeVal = entry?.route;
                  return routeVal === this.router.url || routeVal === '/' + lastSegment;
                });
                if (routeMatchKey) {
                  this.selectedId.set(routeMatchKey);
                  // console.log('Route matched menuContent key without sideMenu:', routeMatchKey);
                  this.secondaryLabel = json.menuContent[routeMatchKey]?.tab || '';
                } else {
                  // 3. Fallback to first key
                  const firstKey = Object.keys(json.menuContent)[0];
                  if (firstKey) {
                    this.selectedId.set(firstKey);
                    // console.log('Fallback to first menuContent key without sideMenu:', firstKey);
                    this.secondaryLabel = json.menuContent[firstKey]?.tab || '';
                  } else {
                    console.warn('menuContent empty; cannot set selectedId.');
                  }
                }
              }
            }
          }

          // console.log(matchedItem, json.sideMenu?.[0]?.contentId, "lastSegment", lastSegment);


          // this.selectedId.set(matchedItem?.contentId || json.sideMenu?.[0]?.contentId || '');
          this.showLoading = false;
          this.showContent = true;
          this.cdr.detectChanges();
          this.scrollToTop();
        },
        error: (err) => {
          console.error('Error loading data:', err);
          console.error('Failed path:', dataPath);
          this.data.set({ pageName: '', sideMenu: [], menuContent: {} });
          this.showLoading = false;
          this.showContent = false;
          this.cdr.detectChanges();
        }
      });
    }
  }


  callAPItoGetData(json: any, contentId: string) {
    // Check if API call is already in progress for this contentId
    if (this.isLoadingData[contentId]) {
      // console.log(`API call already in progress for ${contentId}, skipping duplicate request`);
      return;
    }
    this.showShimmer = true;
    this.noData = false;

    const apiUrls: { [key: string]: string } = {
      "team-members": ApiConstants.API_GET_Profile_TeamMembers,
      "bank-details": ApiConstants.API_GET_Profile_BankAccounts
    };

    const apiUrl = apiUrls[contentId];
    if (!apiUrl) {
      console.warn(`No API URL mapped for contentId: ${contentId}`);
      return;
    }

    let urlToCall = apiUrl;
    if (contentId === 'bank-details') {
      const bin = this.getViewingDifferentUserBin();
      if (bin) {
        urlToCall = `${apiUrl}?bin=${encodeURIComponent(bin)}`;
      }
    }

    this.isLoadingData[contentId] = true;
    // console.log(`Starting API call for ${contentId}...`);

    this.apiService.get<any>(urlToCall).subscribe({
      next: (response) => {
        this.isLoadingData[contentId] = false;
        // console.log('Data fetched from API:', response);
        if (response.success && response.data) {
          const { tableHeadings, tableData } = response.data;
          const components = json['menuContent'][contentId].components;

          for (const group of components) {
            for (const component of group.components) {
              if (component.type === 'table' && component.data?.length > 0) {
                component.data[0].tableHeadings = tableHeadings;
                component.data[0].tableData = tableData;
              }
            }
          }

          // console.log('Updated JSON with API data:', json);
          this.data.set({ ...json });
          this.showShimmer = false;
          this.noData = false;
          this.cdr.markForCheck();
        }
      },
      error: (error) => {
        this.isLoadingData[contentId] = false;
        console.error('Error fetching data from API:', error);
        this.showLoading = false;
        this.noData = true;
        this.showShimmer = false;
        this.isLoadingData[contentId] = false;
        // console.error('Error fetching data from API:', error);
        this.cdr.markForCheck();
      }
    });
  }


  refreshDataForContent(contentId: string) {
    // Check if refresh is already in progress for this contentId
    if (this.isLoadingData[contentId]) {
      // console.log(`Refresh already in progress for ${contentId}, skipping duplicate refresh`);
      return;
    }

    const currentData = this.data();
    if (currentData && currentData.menuContent && currentData.menuContent[contentId]) {
      // console.log(`Refreshing data for content: ${contentId}`);
      this.callAPItoGetData(currentData, contentId);
    } else {
      // console.warn(`Content '${contentId}' not found in current data structure`);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.routeSub) this.routeSub.unsubscribe();
  }

}

